import { SignatureStatus } from '../providers/api/dtos';

export const signatureStatusLabels: { [key in SignatureStatus]: string } = {
  [SignatureStatus.SIGNED]: 'Firmato',
  [SignatureStatus.ONGOING]: 'In attesa di firma',
  [SignatureStatus.EXPIRED]: 'Scaduto',
  [SignatureStatus.CANCELED]: 'Annullato',
};
